import NextImage, { ImageProps } from "next/legacy/image";
import {useState, FC} from "react";
import googleBucketLoader from "../lib/google-bucket-loader";

export const Image:FC<ImageProps> = (props) => {

    const [blur, setBlur] = useState(true);


    return (
        <NextImage
            {...(props)}
            loader={googleBucketLoader}
            // className={blur ? 'img-blur' : 'unblur'} //classes are in global.scss
            // onLoadingComplete={() => setBlur(false)}
        />
    );

}
